import { Failure, Success } from "@indietabletop/appkit";

export type ValidKey = string | number;

export type ItemNotFoundFailure = {
  type: "ITEM_NOT_FOUND";
  missingKey: ValidKey;
};

export type LookupResult<T> = Success<T> | Failure<ItemNotFoundFailure>;

export class Lookup<K extends ValidKey, V> {
  static fromItems<I extends { id: ValidKey }>(items: I[]) {
    return new Lookup(items.map((i) => [i.id, i]));
  }

  private map: Map<K, V>;

  constructor(iterable?: Iterable<readonly [K, V]>) {
    this.map = new Map(iterable);
  }

  get(key: K) {
    const item = this.map.get(key);

    if (item) {
      return new Success(item);
    }

    return new Failure<ItemNotFoundFailure>({
      type: "ITEM_NOT_FOUND",
      missingKey: key,
    });
  }

  toArray() {
    return Array.from(this.map.values());
  }
}
